import { EOtherIncomeType } from '@if/core/types'
import { formatCurrencyNoDecimals } from '@if/core/utils'
import { ActionList, BodyText, type Action } from '@if/mui'
import { ListItem, ListItemText, Tooltip } from '@mui/material'
import { ApplicantOtherIncome } from '@src/types/CreditApplicationSchema'
import { Pencil, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  onDelete?: () => void
  onEdit?: () => void
  data: ApplicantOtherIncome
  disableEdit: boolean
  toolTip: string
}

const DisplayOtherIncomeListItem = ({ onDelete, onEdit, data, disableEdit, toolTip }: Props) => {
  const { t } = useTranslation()
  const typeLabel = t(`EOtherIncomeType.${data.typeId as EOtherIncomeType}`, { ns: 'enum' })
  const primary = data.description ? `${typeLabel} — ${data.description}` : typeLabel

  const actions: Action[] = [
    ...(onEdit ? [{ icon: Pencil, label: t('common.edit'), onClick: onEdit, disabled: disableEdit }] : []),
    ...(onDelete
      ? [
          {
            icon: Trash2,
            label: t('common.delete'),
            tone: 'destructive' as const,
            onClick: onDelete,
            disabled: disableEdit,
          },
        ]
      : []),
  ]

  return (
    <ListItem sx={{ pr: 10 }} disableGutters secondaryAction={<ActionList actions={actions} />}>
      <Tooltip title={toolTip}>
        <ListItemText primary={<BodyText>{`${primary} : ${formatCurrencyNoDecimals(data.annualAmount)}`}</BodyText>} />
      </Tooltip>
    </ListItem>
  )
}

export default DisplayOtherIncomeListItem
